import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Icon } from '@fiverr-private/fit';
import { TYPES, normalizeDrawerType } from '../../NotificationsDrawer/types';
import ButtonTab from '../ButtonTab';
import * as apps from '../../enums/apps';
import envelope from '../NotificationsPopover/envelope';
import bell from '../NotificationsPopover/bell';

const appList = [apps.APP_NAME_NOTIFICATIONS, apps.APP_NAME_INBOX];

export const getHeaderComponent = ({ drawerType, count, active, onClick }) => {
    const normalizedType = normalizeDrawerType(drawerType);
    switch (normalizedType) {
        case TYPES.NOTIFICATIONS:
            return (
                <>
                    <Icon className="header-icon bell">{bell}</Icon>
                    <I18n k="realtime_notifications.notifications_drawer.notifications" /> (
                    {count[apps.APP_NAME_NOTIFICATIONS]})
                </>
            );
        case TYPES.MESSAGES:
            return (
                <>
                    <Icon className="header-icon envelope">{envelope}</Icon>
                    <I18n k="realtime_notifications.notifications_drawer.inbox" /> ({count[apps.APP_NAME_INBOX]})
                </>
            );
        case TYPES.BOTH:
        default:
            return appList.map((name) => (
                <ButtonTab key={name} onClick={onClick} active={active === name} name={name} />
            ));
    }
};
